import React from 'react';
import {
  IconButton,
  DrawerHeader,
  DrawerTitle,
  Button,
} from '@one-thd/sui-atomic-components';
import { ArrowBack, Close } from '@one-thd/sui-icons';

interface IMWDrawerHeader {
  setDrawerToDefaultState: () => void;
  isSubmenu: boolean;
  toggleDrawer: () => void;
  menuTitle: string | null;
}

const MWDrawerHeader: React.FC<IMWDrawerHeader> = ({
  setDrawerToDefaultState,
  isSubmenu,
  toggleDrawer,
  menuTitle,
}) => {
  return (
    <DrawerHeader
      title={!isSubmenu ? 'Account Menu' : undefined}
      startAdornment={
        isSubmenu && (
          <Button
            aria-label="back"
            variant="ghost"
            startIcon={ArrowBack}
            className="sui-btn sui-btn-ghost sui-btn-ghost-active sui-btn-ghost-focus sui-btn-ghost-hover sui-leading-normal sui-line-clamp-unset sui-normal-case sui-text-base sui-tracking-normal"
            onClick={() => setDrawerToDefaultState()}
          >
            Back
          </Button>
        )
      }
      endAdornment={
        <IconButton aria-label="close" onClick={toggleDrawer} icon={Close} />
      }
    >
      {isSubmenu && <DrawerTitle>{menuTitle}</DrawerTitle>}
    </DrawerHeader>
  );
};

export { MWDrawerHeader };
